// components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * 路由守卫：检查 localStorage.sessionToken
 * 无 token → 跳转登录页
 */
function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = localStorage.getItem('sessionToken');

  if (!token) {
    // 记住原本想访问的路径，登录后可以 redirect 回来
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
